import format from 'date-fns/format'

export default (date: string | Date) => format(date, 'YYYY-MM-DD')
